import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { useIsClient } from '@alfa-bank/site-helpers-common/browser/use-is-client';
import { selectAppData, selectSmsData } from '@alfa-bank/site-dc-form-api/store';

import { smsStepAnalytics, verifySmsStepAnalytics } from '../../../analytics';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const useAnalytics = (countdownDuration: number) => {
    const isClient = useIsClient();
    const { changePhoneButtonVisible, status } = useSelector(selectAppData);
    const { screen } = useSelector(selectSmsData);
    const { current: analytics } = useRef(
        status === 'NEED_SMS' ? verifySmsStepAnalytics : smsStepAnalytics
    );

    const sendEventOnFinished = (resStatus?: string) => {
        if (resStatus === 'SMS_ERROR') {
            sendEvent(analytics.submit.fail);
        } else {
            sendEvent(analytics.submit.success);
        }
    };

    const sendEventOnRepeat = () => {
        if (screen === 'INITIAL') {
            sendEvent(analytics.resendButton.click);
        }

        if (screen === 'FATAL_ERROR') {
            sendEvent(analytics.fail.click);
        }
    };

    useEffect(() => {
        if (screen === 'FATAL_ERROR') {
            sendEvent(analytics.fail.view);
        }
    }, [analytics.fail.view, screen]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            sendEvent(analytics.resendButton.view);
        }, countdownDuration);

        if (screen !== 'INITIAL') {
            clearTimeout(timeout);
        }

        return () => clearTimeout(timeout);
    }, [analytics.resendButton.view, countdownDuration, screen]);

    useEffect(() => {
        if (changePhoneButtonVisible) {
            sendEvent(analytics.changePhoneButton.view);
        }
    }, [analytics.changePhoneButton.view, changePhoneButtonVisible]);

    useEffect(() => {
        if (isClient && screen === 'INITIAL') {
            /** В Confirmation нету колбека на onChange, поэтому вешаем
             * обработчик c аналитикой напрямую на инпут первой цифры
             * */
            const fisrtCharInput = document.querySelector(
                '[data-test-id="dc-form-sms-confirmation"] input'
            );

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const listener = (event: any) => {
                if (event.target.value.length > 0) {
                    sendEvent(analytics.change);
                }
            };

            fisrtCharInput?.addEventListener('change', listener);

            return () => {
                fisrtCharInput?.removeEventListener('change', listener);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClient, screen]);

    return {
        analytics,
        sendEventOnFinished,
        sendEventOnRepeat,
    };
};
